/**
 * The working idea is that we can have Small, Medium, and Large transitions.
 * Smaller elements use a larger transition duration (ie time) since there is a smaller
 * proportional offset than with larger elements.
 *
 * Here is a helpful article:
 * https://uxdesign.cc/the-ultimate-guide-to-proper-use-of-animation-in-ux-10bd98614fa9
 *
 * Also, lets try to use specific transition properties (ie, transform, bottom, rotate, etc..)
 * Full list: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_animated_properties
 */
const transitionTransformMedium = () => `
   transition: transform 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
`;

/** All keyframe animations here... */
const slideDown = () => `
@keyframes slideDown {
    0% {
      transform: translateY(-100%);
    }

    100% {
      transform: none;
    }
  }
`;

export { transitionTransformMedium, slideDown };
